// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "re-formality/src/Formality.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Formality__ReactUpdate from "re-formality/src/Formality__ReactUpdate.bs.js";
import * as Utils_Form$DvmAdminFrontendFr from "../../../common/utils/Utils_Form.bs.js";

var validators_brand = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var brand = Utils_Form$DvmAdminFrontendFr.validateRequired(param.brand);
      if (brand.TAG === /* Ok */0) {
        return Utils_Form$DvmAdminFrontendFr.validateMaxCharacters(brand._0, 3);
      } else {
        return {
                TAG: /* Error */1,
                _0: brand._0
              };
      }
    })
};

var validators_brandLabel = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      return Utils_Form$DvmAdminFrontendFr.validateRequired(param.brandLabel);
    })
};

var validators_startDate = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var endDate = param.endDate;
      var startDate = param.startDate;
      if (!Belt_Option.isNone(endDate)) {
        return Utils_Form$DvmAdminFrontendFr.validateRequiredDateCompare(startDate, endDate, "smaller", false, undefined, undefined);
      }
      var date = Utils_Form$DvmAdminFrontendFr.validateDate(startDate, undefined);
      if (date.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: date._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: date._0
              };
      }
    })
};

var validators_endDate = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var endDate = param.endDate;
      var startDate = param.startDate;
      if (Belt_Option.isNone(endDate)) {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
      if (!Belt_Option.isNone(startDate)) {
        return Utils_Form$DvmAdminFrontendFr.validateRequiredDateCompare(startDate, endDate, "larger", false, undefined, undefined);
      }
      var date = Utils_Form$DvmAdminFrontendFr.validateDate(endDate, undefined);
      if (date.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: date._0
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: date._0
              };
      }
    })
};

var validators = {
  brand: validators_brand,
  brandLabel: validators_brandLabel,
  startDate: validators_startDate,
  endDate: validators_endDate
};

function initialFieldsStatuses(_input) {
  return {
          brand: /* Pristine */0,
          brandLabel: /* Pristine */0,
          startDate: /* Pristine */0,
          endDate: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            brand: /* Pristine */0,
            brandLabel: /* Pristine */0,
            startDate: /* Pristine */0,
            endDate: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.brand;
  var match_0 = match ? match._0 : Curry._1(validators.brand.validate, input);
  var match$1 = fieldsStatuses.brandLabel;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.brandLabel.validate, input);
  var match$2 = fieldsStatuses.startDate;
  var match_0$2 = match$2 ? match$2._0 : Curry._1(validators.startDate.validate, input);
  var match$3 = fieldsStatuses.endDate;
  var match_0$3 = match$3 ? match$3._0 : Curry._1(validators.endDate.validate, input);
  var brandResult = match_0;
  var brandResult$1;
  if (brandResult.TAG === /* Ok */0) {
    var brandLabelResult = match_0$1;
    if (brandLabelResult.TAG === /* Ok */0) {
      var startDateResult = match_0$2;
      if (startDateResult.TAG === /* Ok */0) {
        var endDateResult = match_0$3;
        if (endDateResult.TAG === /* Ok */0) {
          return {
                  TAG: /* Valid */0,
                  output: {
                    brand: brandResult._0,
                    brandLabel: brandLabelResult._0,
                    startDate: startDateResult._0,
                    endDate: endDateResult._0
                  },
                  fieldsStatuses: {
                    brand: /* Dirty */{
                      _0: brandResult,
                      _1: /* Shown */0
                    },
                    brandLabel: /* Dirty */{
                      _0: brandLabelResult,
                      _1: /* Shown */0
                    },
                    startDate: /* Dirty */{
                      _0: startDateResult,
                      _1: /* Shown */0
                    },
                    endDate: /* Dirty */{
                      _0: endDateResult,
                      _1: /* Shown */0
                    }
                  },
                  collectionsStatuses: undefined
                };
        }
        brandResult$1 = brandResult;
      } else {
        brandResult$1 = brandResult;
      }
    } else {
      brandResult$1 = brandResult;
    }
  } else {
    brandResult$1 = brandResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            brand: /* Dirty */{
              _0: brandResult$1,
              _1: /* Shown */0
            },
            brandLabel: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            startDate: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            endDate: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurBrandField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.brand, validators_brand, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  brand: status,
                                  brandLabel: init.brandLabel,
                                  startDate: init.startDate,
                                  endDate: init.endDate
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurBrandLabelField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.brandLabel, validators_brandLabel, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  brand: init.brand,
                                  brandLabel: status,
                                  startDate: init.startDate,
                                  endDate: init.endDate
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurStartDateField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.startDate, validators_startDate, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  brand: init.brand,
                                  brandLabel: init.brandLabel,
                                  startDate: status,
                                  endDate: init.endDate
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurEndDateField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.endDate, validators_endDate, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  brand: init.brand,
                                  brandLabel: init.brandLabel,
                                  startDate: init.startDate,
                                  endDate: status
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */4 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : error._0;
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              Curry._2(onSubmit, output, {
                                    notifyOnSuccess: (function (input) {
                                        Curry._1(dispatch, {
                                              TAG: /* SetSubmittedStatus */4,
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        Curry._1(dispatch, {
                                              TAG: /* SetSubmissionFailedStatus */5,
                                              _0: error
                                            });
                                      }),
                                    reset: (function (param) {
                                        Curry._1(dispatch, /* Reset */7);
                                      }),
                                    dismissSubmissionResult: (function (param) {
                                        Curry._1(dispatch, /* DismissSubmissionResult */6);
                                      })
                                  });
                            })
                        };
                  break;
              case /* DismissSubmissionError */5 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */6 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */7 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateBrandField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.brand, state.submissionStatus, validators_brand, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            brand: status,
                                            brandLabel: init.brandLabel,
                                            startDate: init.startDate,
                                            endDate: init.endDate
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateBrandLabelField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.brandLabel, state.submissionStatus, validators_brandLabel, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            brand: init.brand,
                                            brandLabel: status,
                                            startDate: init.startDate,
                                            endDate: init.endDate
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateStartDateField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses = {
                    contents: state.fieldsStatuses
                  };
                  var result$4 = Formality.validateDependentFieldOnChange(nextInput$2, nextFieldsStatuses.contents.endDate, validators_endDate, (function (status) {
                          var init = nextFieldsStatuses.contents;
                          return {
                                  brand: init.brand,
                                  brandLabel: init.brandLabel,
                                  startDate: init.startDate,
                                  endDate: status
                                };
                        }));
                  if (result$4 !== undefined) {
                    nextFieldsStatuses.contents = result$4;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, nextFieldsStatuses.contents.startDate, state.submissionStatus, validators_startDate, (function (status) {
                                    var init = nextFieldsStatuses.contents;
                                    return {
                                            brand: init.brand,
                                            brandLabel: init.brandLabel,
                                            startDate: status,
                                            endDate: init.endDate
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateEndDateField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$1 = {
                    contents: state.fieldsStatuses
                  };
                  var result$5 = Formality.validateDependentFieldOnChange(nextInput$3, nextFieldsStatuses$1.contents.startDate, validators_startDate, (function (status) {
                          var init = nextFieldsStatuses$1.contents;
                          return {
                                  brand: init.brand,
                                  brandLabel: init.brandLabel,
                                  startDate: status,
                                  endDate: init.endDate
                                };
                        }));
                  if (result$5 !== undefined) {
                    nextFieldsStatuses$1.contents = result$5;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, nextFieldsStatuses$1.contents.endDate, state.submissionStatus, validators_endDate, (function (status) {
                                    var init = nextFieldsStatuses$1.contents;
                                    return {
                                            brand: init.brand,
                                            brandLabel: init.brandLabel,
                                            startDate: init.startDate,
                                            endDate: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */4 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                brand: /* Pristine */0,
                                brandLabel: /* Pristine */0,
                                startDate: /* Pristine */0,
                                endDate: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                brand: /* Pristine */0,
                                brandLabel: /* Pristine */0,
                                startDate: /* Pristine */0,
                                endDate: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */5 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */6 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Curry._1(map, error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateBrand: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateBrandField */0,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateBrandLabel: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateBrandLabelField */1,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateStartDate: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateStartDateField */2,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateEndDate: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateEndDateField */3,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          blurBrand: (function (param) {
              Curry._1(dispatch, /* BlurBrandField */0);
            }),
          blurBrandLabel: (function (param) {
              Curry._1(dispatch, /* BlurBrandLabelField */1);
            }),
          blurStartDate: (function (param) {
              Curry._1(dispatch, /* BlurStartDateField */2);
            }),
          blurEndDate: (function (param) {
              Curry._1(dispatch, /* BlurEndDateField */3);
            }),
          brandResult: Formality.exposeFieldResult(state.fieldsStatuses.brand),
          brandLabelResult: Formality.exposeFieldResult(state.fieldsStatuses.brandLabel),
          startDateResult: Formality.exposeFieldResult(state.fieldsStatuses.startDate),
          endDateResult: Formality.exposeFieldResult(state.fieldsStatuses.endDate),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.brand || match.brandLabel || match.startDate || match.endDate) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              Curry._1(dispatch, /* Submit */4);
            }),
          dismissSubmissionError: (function (param) {
              Curry._1(dispatch, /* DismissSubmissionError */5);
            }),
          dismissSubmissionResult: (function (param) {
              Curry._1(dispatch, /* DismissSubmissionResult */6);
            }),
          mapSubmissionError: (function (map) {
              Curry._1(dispatch, {
                    TAG: /* MapSubmissionError */6,
                    _0: map
                  });
            }),
          reset: (function (param) {
              Curry._1(dispatch, /* Reset */7);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var initialInput = {
  brand: "",
  brandLabel: "",
  startDate: undefined,
  endDate: undefined
};

export {
  Form ,
  initialInput ,
}
/* react Not a pure module */
